import { Component, OnInit } from '@angular/core';
import { ParentsService } from 'src/app/shared/services/parents.service';

@Component({
  selector: 'app-student-tutoring-services',
  templateUrl: './student-tutoring-services.component.html',
  styleUrls: ['./student-tutoring-services.component.scss']
})
export class StudentTutoringServicesComponent implements OnInit {

  enUrl = "";
  esUrl = "";

  constructor(
    private parentService: ParentsService
  ) {}

  ngOnInit() {
    
    this.getTutoringPdfUrl();
  }

  getTutoringPdfUrl(){
    this.parentService.getFeatureConfigurationByName("tutoring_instructions_en").subscribe(
      (response: any) => {
        this.enUrl = response.value;
      },
      (error) => {
        console.error('Error fetching turtoring data:', error);
      }
    );

  this.parentService.getFeatureConfigurationByName("tutoring_instructions_es").subscribe(
      (response: any) => {
        this.esUrl = response.value;
      },
      (error) => {
        console.error('Error fetching turtoring data:', error);
      }
    );
  }

}

